var React = require('react');

function BgPageBannerV2TopMobileInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#2c4965","d":"M414,76.5,232.27,5.69C222.17,1.75,208.76-.15,195.51,0c-13.41-.16-26.92,1.68-37.07,5.63L0,66.93v13.6l414,.53Z"}));
}

BgPageBannerV2TopMobileInline.defaultProps = {"aria-hidden":"true","data-name":"Calque 1","viewBox":"0 0 414 81.06"};

module.exports = BgPageBannerV2TopMobileInline;

BgPageBannerV2TopMobileInline.default = BgPageBannerV2TopMobileInline;
